export default __webpack_public_path__ + "static/media/event-image.cf436f3c.png";